import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../../lib/preact-pure-component'
import classNames from 'classnames'
import { Role } from '../index'

interface Props {
  role: Role
}

export class Category extends PureComponent<Props, {}> {
  render() {
    const { role } = this.props
    const names = role.names.map(name => <div key={name.name}>{name.name}</div>)

    return (
      <div>
        <h3 className={style.header}>{role.text}</h3>
        {names}
      </div>
    )
  }
}
